import { Grid2, Box, Button, Typography, SxProps } from "@mui/material";
import { Link } from "react-router";
import { HowItWorksBlock } from "../../pages/landing-page/how-it-works-block";
import { Pages } from "../../utils";
import { LandingPageSection } from "../static-page-components/landing-page-section";

export const TheVettingProcess = ({ sx }: { sx?: SxProps }) => {
  return (
    <LandingPageSection
      sx={sx}
      className="vetting-process-section green-section"
    >
      <Typography
        variant={"display2" as any}
        component="h2"
        className="section-title text-center"
        sx={{ mb: "16px" }}
      >
        THE VETTING PROCESS
      </Typography>
      <Typography
        variant="body1"
        className="text-center contain-text-small section-subtitle font-size-4"
        sx={{
          mb: "40px !important",
        }}
      >
        Once you apply, the membership process takes roughly a week to complete.
        Log into your Designer Hub at any time to check your application
        progress.
      </Typography>
      <Grid2 container spacing={"40px"} columns={12}>
        <HowItWorksBlock
          number={1}
          title="APPLY"
          description="Complete your application at your own pace and click submit when you’re ready."
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        />
        <HowItWorksBlock
          number={2}
          title="MEET"
          description="After you submit your application, you’ll receive a link to book a virtual one-on-one call. "
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        />
        <HowItWorksBlock
          number={3}
          title="VERIFY"
          description="HDG verifies your references, reviews and social presence."
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        />
        <HowItWorksBlock
          number={4}
          title="APPROVED/DENIED"
          description="With Steps 1-3 complete, you’ll receive an email with our decision."
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        />
        <HowItWorksBlock
          number={5}
          title="PAYMENT"
          description="Once you’re approved, you’ll submit your membership payment."
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        />
        <HowItWorksBlock
          number={6}
          title="WELCOME"
          description="Upon payment, you will receive your Welcome & Onboarding Toolkit."
          size={{
            xs: 12,
            sm: 6,
            md: 4,
          }}
        />
      </Grid2>
      <Box className="text-center" sx={{ mt: "52px" }}>
        <Button
          variant="contained"
          size="large"
          to={Pages.DESIGNER_MEMBERSHIP_PRICING}
          component={Link}
          color={"white" as any}
          className="font-size-4 font-body"
        >
          View Membership Levels & Pricing
        </Button>
      </Box>
    </LandingPageSection>
  );
};
